import actions from "./actions";
import mutations from "./mutations";
import i18n from "../../../i18n";

export default {
  namespaced: true,
  state: {
    tab: i18n.t("room.tabs.info"),
    isDrawing: false,
    updatingRoom: false,
    addingRoom: false,
    room_id: null,
    name: undefined,
    room_info_comment: undefined,
    room_image_url: undefined,
    measurement_points_comment: undefined,
    room_type: undefined,
    room_type_id: null,
    longer_size_length: 1,
    corners: [],
    illumination_tests: [],
    functional_tests: [],
    measurement_points: [],
    measurement_height: 0.75,
    closed: false,
    isRoomValid: true,
    distance_between_points_x: 0,
    distance_between_points_y: 0,
    distance_from_wall: 0,
    max_distance_between_points: 0,
    freezeDistanceBetweenPoints: false,
    selected_test_id: null,
    selected_measurement_point_id: null,
    room_types: null,
  },
  mutations,
  actions,
};
